import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'
import AutoFixNormalOutlinedIcon from '@mui/icons-material/AutoFixNormalOutlined'
import BlurOnOutlinedIcon from '@mui/icons-material/BlurOnOutlined'
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined'
import CloudOffOutlinedIcon from '@mui/icons-material/CloudOffOutlined'
import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined'
import CropFreeOutlinedIcon from '@mui/icons-material/CropFreeOutlined'
import CropOutlinedIcon from '@mui/icons-material/CropOutlined'
import FilterOutlinedIcon from '@mui/icons-material/FilterOutlined'
import FormatColorFillOutlinedIcon from '@mui/icons-material/FormatColorFillOutlined'
import FormatPaintOutlinedIcon from '@mui/icons-material/FormatPaintOutlined'
import { GRAY_800 } from 'constants/styling/theme'
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined'
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined'
import ZoomOutMapOutlinedIcon from '@mui/icons-material/ZoomOutMapOutlined'

export enum AI_TOOLS {
  AI_MAGIC_ERASER = 'AI_MAGIC_ERASER',
  AI_AUTO_ENHANCEMENT = 'AI_AUTO_ENHANCEMENT',
  AI_SKY_REPLACEMENT = 'AI_SKY_REPLACEMENT',
  AI_WALL_PAINTING = 'AI_WALL_PAINTING',
}

export enum MANUAL_TOOLS {
  CROP = 'CROP',
  FINE_TUNE = 'FINE_TUNE',
  FILTERS = 'FILTERS',
  ANNOTATE = 'ANNOTATE',
  STICKER = 'STICKER',
  FILL = 'FILL',
  REDACT = 'REDACT',
  FRAME = 'FRAME',
  RESIZE = 'RESIZE',
}

const comingSoonTools = [AI_TOOLS.AI_WALL_PAINTING, AI_TOOLS.AI_SKY_REPLACEMENT, AI_TOOLS.AI_AUTO_ENHANCEMENT]

export const getAIToolIcon = (tool: string) => {
  switch (tool) {
    case AI_TOOLS.AI_AUTO_ENHANCEMENT:
      return <AutoAwesomeOutlinedIcon sx={{ color: GRAY_800 }} />
    case AI_TOOLS.AI_MAGIC_ERASER:
      return <AutoFixNormalOutlinedIcon sx={{ color: GRAY_800 }} />
    case AI_TOOLS.AI_SKY_REPLACEMENT:
      return <CloudOffOutlinedIcon sx={{ color: GRAY_800 }} />
    case AI_TOOLS.AI_WALL_PAINTING:
      return <FormatPaintOutlinedIcon sx={{ color: GRAY_800 }} />
    default:
      return <AutoAwesomeOutlinedIcon sx={{ color: GRAY_800 }} />
  }
}

export const getManualToolIcon = (tool: string) => {
  switch (tool) {
    case MANUAL_TOOLS.CROP:
      return <CropOutlinedIcon sx={{ color: GRAY_800 }} />
    case MANUAL_TOOLS.FINE_TUNE:
      return <TuneOutlinedIcon sx={{ color: GRAY_800 }} />
    case MANUAL_TOOLS.FILTERS:
      return <FilterOutlinedIcon sx={{ color: GRAY_800 }} />
    case MANUAL_TOOLS.ANNOTATE:
      return <BorderColorOutlinedIcon sx={{ color: GRAY_800 }} />
    case MANUAL_TOOLS.STICKER:
      return <StickyNote2OutlinedIcon sx={{ color: GRAY_800 }} /> // todo figure out where BB got the StickyCircle icon? not included in MUI
    case MANUAL_TOOLS.FILL:
      return <FormatColorFillOutlinedIcon sx={{ color: GRAY_800 }} />
    case MANUAL_TOOLS.REDACT:
      return <BlurOnOutlinedIcon sx={{ color: GRAY_800 }} />
    case MANUAL_TOOLS.FRAME:
      return <CropFreeOutlinedIcon sx={{ color: GRAY_800 }} />
    case MANUAL_TOOLS.RESIZE:
      return <ZoomOutMapOutlinedIcon sx={{ color: GRAY_800 }} />
    default:
      return <ConstructionOutlinedIcon sx={{ color: GRAY_800 }} />
  }
}

export const getIsComingSoonTool = (tool: AI_TOOLS) => comingSoonTools.includes(tool)
